import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { Fonts } from '../../../styles/styles';

const { colors, space } = THEME;

export const styleSheet = StyleSheet.create({
	compactFlag: {
		position: 'absolute',
		right: 0,
		top: space[4],
	},
	container: {},
	clickFocusTarget: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		justifyContent: 'inherit',
		outline: 'none',
		padding: `${space[4]}px ${space[16]}px`,
		width: '100%',
	},
	flag: {
		marginLeft: 10,
	},
	icon: {
		display: 'flex',
		height: 20,
		justifyContent: 'center',
		textAlign: 'center',
		verticalAlign: 'middle',
		width: 22,
	},
	linkFocusOnTabOnly: {
		':focus-visible': {
			borderRadius: '0.75rem',
			outline: `2px solid ${colors.background.light}`,
			outlineOffset: -2,
		},
		outline: 'none',
		padding: 0,
	},
	linkName: {
		fontFamily: Fonts.lexend,
		marginLeft: 15,
	},
	linkNameOutlined: {
		border: `1px solid ${colors.primary.main}`,
		borderRadius: 3,
		padding: '4px 10px',
	},
});
